import { z } from 'zod';

import { VenueWritableShape } from '../venue-create/venue-create';

/**
 * A partial edit of a venue.
 *
 * It is partial for **one** caller: the venues list's inline publication Switch
 * (W7), which sends `{ isActive }` and nothing else. "Leave the copy alone" is
 * the entire point of that control, and it is the only justification a partial
 * write contract needs.
 *
 * **The editor form does NOT use this schema** — it writes with
 * `VenueCreateSchema` even when editing. A form built on the partial makes every
 * field optional, so an operator can clear a venue's name and save it.
 *
 * Partial means "this field may be absent", never "this field may be half
 * supplied": `translations` is still the complete map when it is sent at all, so
 * a venue cannot be edited into a single language (U8).
 */
export const VenueUpdateSchema = z.object(VenueWritableShape).partial().strict();

export type VenueUpdateRequest = z.infer<typeof VenueUpdateSchema>;
